import React from 'react';

export const LeftDirectionArrow = () => {
    return (
        <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M13.1673 7.99967H3.83398M3.83398 7.99967L8.50065 12.6663M3.83398 7.99967L8.50065 3.33301" stroke="#020617" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    )
}